/**
 * @file openapi跳转相关
 * @author quda
 */
import {getParamsFromUrl, getPlatInfo, openBdMap, requestBdApi} from '@baidu/map-fe-utils';
import Const from '@/pages/pano-game/constant/Constant';

const src = 'cjh.pano-game.jump';
const urlParams = getParamsFromUrl(); // 页面参数
// const from = urlParams.fr || 'default'; // 页面来源
const platInfo = getPlatInfo();

/**
 * 触发iOS返回webview事件
 */
function registerIOSBack() {
    if (platInfo.isNative && platInfo.isIos) {
        requestBdApi('bdapi://robackRefresh');
    }
}

/**
 * 关闭页面
 */
export const closeNativePage = () => {
    if (platInfo.isNative) {
        registerIOSBack();
        requestBdApi('bdapi://finishpage?needUpdate=1');
    }
    else {
        window.history.go(-1);
    }
};

// 设置透明壳返回按钮
export const updateReturnBtn = () => {
    if (platInfo.isNative && platInfo.isIos) {
        requestBdApi('bdapi://updatetitle?backBtnColor=white&hidetitle=1&hideprogress=1');
    }
};

// 调起地图
// const invokeMap = (openapi, isAutoJump = false) => { // 调起
//     yymap.naa.openClient({
//         openapi: openapi,
//         iosTime: 3000
//     }, isAutoJump);
//
//     yymap.nativeAppAdapter.jumpHandler.android.others = () => {
//         window.location.href = 'https://map.baidu.com/zt/client/index/?down=android&fr=' + src;
//     };
// };


/**
 * 打开页面基础方法
 * @param {string} url - 跳转url
 */
export const jumpByOpenapi = (
    url,
    // 开发阶段不调起端
    needBackToNative = Const.devTap.needBackToNative,
    isNoBar = true,
    inNativeCallback = null,
    outNativeCallback = null,
) => {
    let base = '';
    let jumpUrl = '';
    // 使用配置文件中的返回地图地址
    const backUrl = Const.devTap.backUrl;
    if (!url) {
        return;
    }
    // 识别openapi协议
    if (url.indexOf('baidumap') > -1) {
        jumpUrl = url;
    }
    // 判断是否透明壳
    else if (isNoBar) {
        base = `baidumap://map/cost_share?popRoot=no&mode=NORMAL_MODE&src=${src}`
          + '&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1&url=';
        jumpUrl = base + encodeURIComponent(url);
    }
    else {
        base = `baidumap://map/cost_share?popRoot=no&mode=NORMAL_MODE&src=${src}&hideshare=1&url=`;
        jumpUrl = base + encodeURIComponent(url);
    }
    if (platInfo.isNative) {
        platInfo.isIos && registerIOSBack();
        location.href = jumpUrl;
        inNativeCallback && inNativeCallback();
    }
    else {
        if (needBackToNative) {
            const jumpUrl = base + encodeURIComponent(backUrl);
            openBdMap(jumpUrl);
            // if (platInfo.isIos) {
            //     openBdMap(jumpUrl);
            // }
            // else {
            // }
        }
        else {
            // window.open(url);
            location.href = url;
        }
        outNativeCallback && outNativeCallback();
    }
};

/**
 * 拼接跳转指定端时光机组件OpenAPI
 * @param {string} uid - 景点uid
 * @see => http://wiki.baidu.com/pages/viewpage.action?pageId=431468602
 */
export const jumpFinePano = uid => {
    const url = `https://scenes.map.baidu.com/static/h5-project/fine-pano/fine-pano.html?uid=${uid}&fr=${src}&isTransparent=1`;
    jumpByOpenapi(`baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRoot=no&hiddenBackBtn=1&hiddenTitle=1&needLocation=no&url=${encodeURIComponent(url)}`);
};

/**
 * 跳转指定时光机
 * @param {string} pid - 全景id
 */
export const jumpPano = pid => {
    const param = {pid, from_source: src};
    const url
        = 'baidumap://map/component?popRoot=no&comName=streetscape&target=street_scape_page&param='
        + encodeURIComponent(JSON.stringify(param));
    jumpByOpenapi(url);
};

/** *********奖品中心************ */
/**
 * 跳转提现中心
 */
export const jumpToCashCenter = eventKey => {
    // const cashCenter = 'http://mapactivity-db.bcc-bdbl.baidu.com:8080/zt/webapp/currency/index.html';
    const cashCenter = 'https://map.baidu.com/zt/webapp/currency/index.html';
    const url = `${cashCenter}?apiversion=2&eventkey=${eventKey}`
      + `&cuid=${urlParams.cuid}&zid=${window.yy.naa.phoneinfo.zid}`;
    jumpByOpenapi(url);
};

/**
 * 跳转奖品中心
 */
export const jumpToPrizeCenter = () => {
    // const prizeCenter = 'http://mapactivity-db.bcc-bdbl.baidu.com:8080/zt/y2018/prizeList/?transparent=1';
    const prizeCenter = 'https://map.baidu.com/zt/y2018/prizeList/index.html?transparent=1';
    jumpByOpenapi(prizeCenter);
};

/**
 * 跳转客户端客服中心
 */
export const jumpFeedback = () => {
    const url = 'baidumap://map/showfeedback?source=1&contactEnable=1&robotEnable=1&faqChannel=1&popRoot=no';
    jumpByOpenapi(url);
};

